export default function HeroBanner() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5aa5d2cc45ac43b0ce62f5d6c0e28b80.jpg"
          alt="The Forgotten Felon Blueprint Hero Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/70 via-amber-950/50 to-stone-900/80"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 w-full max-w-5xl mx-auto">
        <p className="text-amber-400 text-[10px] md:text-sm uppercase tracking-[0.2em] md:tracking-[0.4em] font-semibold mb-4 md:mb-6 leading-relaxed">
          A Survival Guide for Those Who Want Their Freedom to Mean Something
        </p>
        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black text-amber-50 mb-2 tracking-tight leading-none uppercase">
          The Forgotten
        </h1>
        <h1 className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl font-black text-amber-50 mb-2 tracking-tight leading-none uppercase">
          Felon
        </h1>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-amber-400 mb-4 md:mb-6 tracking-[0.15em] md:tracking-[0.2em] uppercase">
          Blueprint
        </h2>
        <div className="w-16 md:w-24 h-0.5 bg-amber-500 mx-auto mb-4 md:mb-6"></div>
        <p className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-black text-amber-100 mb-4 tracking-widest uppercase">
          by John Reed
        </p>
        <p className="text-sm md:text-base md:text-lg italic text-amber-100/70 max-w-2xl mx-auto mb-8 md:mb-12 leading-relaxed px-2">
          "I didn't just walk out of prison — I walked into a war for my future."
        </p>
        <button
          onClick={() => scrollToSection('purchase')}
          className="px-8 md:px-12 py-3 md:py-4 bg-amber-600 text-amber-50 text-sm md:text-base font-bold rounded-none uppercase tracking-widest hover:bg-amber-500 transition-all duration-300 shadow-xl hover:shadow-amber-700/40 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Get Your Copy Now
        </button>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-amber-400 text-3xl"></i>
      </div>
    </section>
  );
}
